// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateStatusChangeModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_PART_COVERAGE_SEARCH_STATUS_CHANGE_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/action-creators/part-coverage-search-modals.js